module.exports = __webpack_public_path__ + "img/paziente.cbc857c2.svg";